.as{max-width:100%;}